/**
 * Contact Form Block JavaScript
 */

(function() {
    'use strict';
    
    // Initialize block functionality
    function initContactForm() {
        const blocks = document.querySelectorAll('.contact-form');
        
        blocks.forEach(block => {
            // Add your block functionality here
            console.log('[BLOCK] contact-form block initialized');
        });
    }
    
    // Initialize on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initContactForm);
    } else {
        initContactForm();
    }
})();